import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"


// components
import Applications from "pages/Dashboard/applications"

// services
import ApplicationService from "../../services/applications/Application.service"
import Staff from "services/staff/Staff"
import ApplicationFilter from "components/Filter/ApplicationFilter"

let appService = null
let plasticsUser = null
let staffService = new Staff()

// All reviews submitted by Officer to the department

const OfficerReviewed = () => {
  const [menu, setMenu] = useState(false)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [reviewed, setreviewed] = useState()
  const [searchMode, setsearchMode] = useState(false)
  const [filterValues, setFilterValues] = useState({
    search: "",
    application_status: "",
    date_from: "",
    date_to: "",
  })

  const toggle = () => {
    setMenu(!menu)
  }

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)

    setuser(userObj)
    plasticsUser = appService.getStrategy("head")
    plasticsUser.getReviewedApplications(1).then(response => {
      if (response.status) {
        setreviewed(response.data)
        setmounted(true)
      }
    })
  }, [])

  useEffect(() => {
    plasticsUser = appService.getStrategy("head")
  })

  const paginate = page => {
    // If we are in search mode, we will call the search endpoint instead
    if (searchMode) {
      appService.searchApplications(filterValues, page).then(response => {
        setreviewed(response.data)
      })
    } else {
      plasticsUser.getReviewedApplications(page).then(response => {
        if (response.status) {
          setreviewed(response.data)
        }
      })
    }
  }

  const initiateSearch = data => {
    data = { ...data, application_status: "REVIEWED" }
    setsearchMode(true)
    setFilterValues(data)
    appService.searchApplications(data, null).then(response => {
      if (response?.code && response.code == 200) {
        if (response.data.total == 0) {
          setreviewed({ data: [] })
        } else {
          setreviewed(response.data)
        }
      } else {
        setreviewed({ data: [] })
      }
    })
  }

  const turnOffSearchMode = () => {
    setsearchMode(false)
    paginate(0)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Reviewed | Staff</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Officer Reviewed</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    These are applications reviewed by Officers waiting for your
                    decision.
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

          {mounted ? (
            <Row>
              <ApplicationFilter
                allApplications={false}
                handleSearch={initiateSearch}
                turnOffSearch={turnOffSearchMode}
              />

              <Applications
                viewOnly={false}
                user={user}
                data={reviewed}
                paginate={paginate}
                hodSubmittedApps={false}
              />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default OfficerReviewed
